import type { LucideIcon } from 'lucide-react'
import { Zap, RefreshCw, CheckCircle2, List } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/utils/cn'

export type QuickFilterType = 'NEEDS_ACTION' | 'IN_PROCESS' | 'DONE' | 'ALL'

interface QuickFilterCounts {
  needsAction: number
  inProcess: number
  done: number
  total: number
}

interface PublicationQuickFiltersProps {
  activeFilter: QuickFilterType
  counts: QuickFilterCounts
  onFilterChange: (filter: QuickFilterType) => void
  loading?: boolean
}

interface QuickFilter {
  type: QuickFilterType
  label: string
  icon: LucideIcon
  count: number
  description: string
}

export function PublicationQuickFilters({
  activeFilter,
  counts,
  onFilterChange,
  loading = false
}: PublicationQuickFiltersProps) {
  const filters: QuickFilter[] = [
    {
      type: 'NEEDS_ACTION',
      label: 'Precisa de Ação',
      icon: Zap,
      count: counts.needsAction,
      description: 'Intimações sem tarefa criada'
    },
    {
      type: 'IN_PROCESS',
      label: 'Em Processamento',
      icon: RefreshCw,
      count: counts.inProcess,
      description: 'Tarefa criada ou vinculadas'
    },
    {
      type: 'DONE',
      label: 'Concluídas',
      icon: CheckCircle2,
      count: counts.done,
      description: 'Arquivadas ou descartadas'
    },
    {
      type: 'ALL',
      label: 'Todas',
      icon: List,
      count: counts.total,
      description: 'Todas as publicações'
    }
  ]

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap gap-2">
        {filters.map(({ type, label, icon: Icon, count, description }) => {
          const active = activeFilter === type
          return (
            <Button
              key={type}
              onClick={() => onFilterChange(type)}
              disabled={loading}
              variant={active ? 'secondary' : 'outline'}
              aria-pressed={active}
              className={cn('h-9', active && 'ring-2 ring-ring/50')}
              title={description}
            >
              <Icon className={cn(active ? 'text-primary' : 'text-muted-foreground')} aria-hidden="true" />
              <span>{label}</span>
              <span className="rounded-full bg-muted px-2 py-0.5 text-xs font-semibold tabular-nums text-foreground">
                {count}
              </span>
            </Button>
          )
        })}
      </div>

      {/* Descrição do filtro ativo */}
      <p className="text-sm text-muted-foreground">
        {filters.find(f => f.type === activeFilter)?.description}
      </p>
    </div>
  )
}
